import ResetPassword from '@/modules/auth/reset-password/reset-password';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  token: z.string().optional()
});

export const Route = createFileRoute('/auth/reset-password/')({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search)
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return <ResetPassword token={token} />;
}
